import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import {
  RequestDetailPhotoDto,
  RequestReportsDto,
  ResponseDetailPhotoDto,
  ResponsePreviewDto
} from "../dto/suspect-att-face-report.dto";

@Injectable()
export class SuspectAttFaceReportApi {
  private readonly service: string = '';
  private readonly model: string = 'SuspectAttFaceReport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public preview(payload: RequestReportsDto): Observable<ResponsePreviewDto> {
    const method: string = 'POST';
    const func: string = 'preview';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePreviewDto>(method, url, params, urlParams, body);
  }

  public downloadExcel(payload: RequestReportsDto): Observable<Blob> {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, params, urlParams, body);
  }

  public downloadPdf(payload: RequestReportsDto): Observable<Blob> {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, params, urlParams, body);
  }

  public reportSendEmailExcel(payload: RequestReportsDto): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailExcel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public reportSendEmailPdf(payload: RequestReportsDto): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailPdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  detailPhoto(data: RequestDetailPhotoDto): Observable<ResponseDetailPhotoDto> {
    const method: string = 'GET';
    const func: string = 'detailPhoto';
    const params: any = {};
    const urlParams: any = data;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDetailPhotoDto>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/suspect-att-face-report.api.ts